(function ($) {
    function noticePopup(notice) {
        var form = $('form', notice),
            mute = $('#mute-notice-popup', form);

        if (notice.length) {
            mute.on('click', function () {
                if (mute.is(':checked')) {
                    notice.modal('hide');
                    $.post(form.attr('action'), form.serialize());
                }
            });

            setTimeout(function () {
                notice.modal('show');
            }, 500);
        }
    }

    /**
     * 구독 팝업 닫기 제어
     *
     * @param pc     PC쪽 래퍼를 넣어준다.
     * @param mobile 모바일쪽 래퍼를 넣어준다.
     */
    function subscriptionPopup(pc, mobile) {
        if (pc.length && mobile.length) {
            var pcMute = $('#mute-subscription-popup-pc'),
                modbileForm = mobile.find('form'),
                mobileMute = modbileForm.find('#mute-subscription-popup-mobile');

            pcMute.add(mobileMute).on('click', function (e) {
                if (e.currentTarget.checked) {
                    modbileForm.submit();
                }
            });

            modbileForm.on('submit', function (e) {
                e.preventDefault();
                pc.hide();
                mobile.hide();
                $.post(modbileForm.attr('action'), modbileForm.serialize(), function () {
                    pc.remove();
                    mobile.remove();
                });
            });
        }
    }

    $(document).ready(function () {
        noticePopup($('#notice'));
        subscriptionPopup($('#pc-banner'), $('#footer-banner'));
    });
})(jQuery);
